export function resolveAddress(values: string[], separator = ','): string {
  const value = values.filter(word => !!word);
  if (!value.length) {
    return '';
  }
  return value.reduce((previous, current) => `${previous}${separator} ${current}`);
}
